import { render, staticRenderFns } from "./titleWrapper.vue?vue&type=template&id=274ddc8a&scoped=true"
import script from "./titleWrapper.vue?vue&type=script&lang=js"
export * from "./titleWrapper.vue?vue&type=script&lang=js"
import style0 from "./titleWrapper.vue?vue&type=style&index=0&id=274ddc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274ddc8a",
  null
  
)

export default component.exports